import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import Button from "../Button/Button";

interface InfoDialogProps extends DialogProps {
  okLabel?: string;
  onClickOk: () => void;
}

export function InfoDialog(props: InfoDialogProps) {
  const {
    children,
    onClickOk,
    open,
    title,
    okLabel = "OK",
  } = props;

  const handleOk = () => {
    onClickOk();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        <span>{title}</span>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleOk}>{okLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
